import { GET_BANK_WISE_DEPOSIT_REPORT } from '../../../Types'
import _ from 'lodash'



const BankWiseDepositReportReducer = (state = [], action) => {
  switch (action.type) {
    case GET_BANK_WISE_DEPOSIT_REPORT:
  return {
    ...state,
    data: action.payload?.data || [],          // Make sure this exists
    totalRecords: action.payload?.totalRecords || 0, // And this exists
  };
    default:
      return state
  }
}
export default BankWiseDepositReportReducer